import React from "react";
import styles from "./dateRefinementMenu.scss";
import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";
import CheckBox from "../../CheckBox";

const DateRefinementMenu = ({
  dateRefinement = null,
  customMenuDirection = "left",
  startDate = "Start Date",
  endDate = "End Date",
  setDateRefinement,
  customDayChange,
  customDateMenuToggle,
  customDateOpen
}) => {
  return (
    <div>
      <CheckBox click={() => setDateRefinement("all")}>All Dates</CheckBox>
      <CheckBox click={() => setDateRefinement("today")}>Today</CheckBox>
      <CheckBox click={() => setDateRefinement("tomorrow")}>Tomorrow</CheckBox>
      <CheckBox click={() => setDateRefinement("thisWeekend")}>
        This Weekend
      </CheckBox>
      <CheckBox click={() => setDateRefinement("thisWeek")}>This Week</CheckBox>
      <CheckBox click={() => setDateRefinement("nextWeek")}>Next Week</CheckBox>
      <p
        className={styles.dropDownTextHighlight}
        onClick={customDateMenuToggle}
      >
        Custom Date
      </p>
      {customDateOpen ? (
        <div className={styles.dateSelectionWrapper}>
          <div className={styles.dateSelector}>
            <div className={`${customMenuDirection}DatePicker`}>
              <DayPickerInput
                onDayChange={e =>
                  customDayChange({ field: "startDate", value: e })
                }
                value={startDate}
                placeholder={"Start Date"}
              />
            </div>
          </div>
          <div className={styles.dateSelector}>
            <div className={`${customMenuDirection}DatePicker`}>
              <DayPickerInput
                onDayChange={e =>
                  customDayChange({ field: "endDate", value: e })
                }
                value={endDate}
                placeholder={"End Date"}
              />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default DateRefinementMenu;
